import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { genURL } from "./../_getjson.js";
import SelectFix from "./SelectFix";
import axios from 'axios'
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Backdrop from './../Components/CustomBackdrop/Barckdrop'


import Grid from '@mui/material/Grid';
require("./../_css/PopUpOther.css");
export const ReDate = (TimeStamp) => {
  var myDate = new Date(TimeStamp);
  var date = (myDate.getDate() < 10 ? "0" : "") + myDate.getDate();
  var month = (myDate.getMonth() + 1 < 10 ? "0" : "") + (myDate.getMonth() + 1);
  var year = myDate.getFullYear() + 543;
  return date + "/" + month + "/" + year;
};
export const startdate = () => {
  var myDate = new Date();
  var date = "01"
  var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
  var year = myDate.getFullYear() + 543;
  return date + "/" + month + "/" + year;
}
const startdate1 = () => {
  var myDate = new Date();
  var date = myDate.getDate();
  var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
  var year = myDate.getFullYear() + 543;
  return date + "/" + month + "/" + year;
}
const ReDate2 = (date) => {
  console.log(date);
  var dateSp = date.split("/");
  var dataRe = dateSp[2] - 543 + "-" + dateSp[1] + "-" + dateSp[0];
  return dataRe;
};
const mystyle = {
  paddingTop: '0px',
  // paddingLeft:'0px'
};
export default class SearchDoc extends React.Component {
  constructor(props) {
    super(props);
    this.onAddBucket = this.onSearch.bind(this);
    this.DOCNO1 = React.createRef();
    this.DOCNO2 = React.createRef();
    this.PRCREATOR = React.createRef();
    this.DOCGROUP = React.createRef();
    this.top = React.createRef("");
    this.state = {
      rows: [],
      Htext: "",
      _from: "",
      hiddenF: false,
      hiddenT: true,
      paybill: true,
      receipt: true,
      openBackdrop: false,
      DATE1: startdate(),
      DATE2: '',

    }
  }
  componentDidMount() {
    this.setState({ _from: this.props.from });
    setTimeout(() => {
      this.onSearch();
    }, 200);
    // this.onAddBucket();
  }

  onClose = (e) => {
    this.props.closePopup();
  };
  ViewCSTV = (DATA) => {
    switch (DATA) {
      case "CSPR":
        this.setState({ Htext: "ใบขอสั่งซื้อ (PR)", APCODE: true });
        return "CSPR/Search?";
      case "CSPURCHASE":
        this.setState({
          Htext: "บันทึกรับสินค้า/ตั้งหนี้/เงินสด",
          APCODE: true,
        });
        return "CSPURCHASE/Search?";
      case "CSARDEPOSIT":
        this.setState({ Htext: "บันทึกรับเงินล่วงหน้า/เงินมัดจำ" });
        return "CSARDEPOSIT/SEARCH?";
      case "CSSALE":
        this.setState({ Htext: "บันทึกขายสินค้าและบริการ" });
        return "CSSALE/SEARCH?";
      case "CSCUSTORDER":
        this.setState({ Htext: "บันทึกใบสั่งจองสินค้า" });
        return "CSCUSTORDER/SEARCH?";
      /* case "CSSALEORDER":  this.setState({Htext:"บันทึกใบสั่งขาย/สั่งจัดสินค้า"});   return "CSSALEORDER/Search?";  */
      case "CSSaleRetReq":
        this.setState({ Htext: "บันทึกใบขอรับคืนสินค้า" });
        return "CSSALERETREQ/SEARCH?";
      case "CSSTKMOVE":
        this.setState({ Htext: "บันทึกใบโอนสินค้า" });
        return "CSSTKMOVE/SEARCH?";
      case "CSSTKMOVEREQ":
        this.setState({ Htext: "บันทึกใบขอโอนสินค้า" });
        return "CSSTKMOVEREQ/SEARCH?";
      case "CSOTHEREXPENSE":
        this.setState({ Htext: "บันทึกค่าใช้จ่ายอื่นๆ" });
        return "CSOTHEREXPENSE/SEARCH?";
      case "CSOTHERINCOME":
        this.setState({ Htext: "บันทึกรายได้อื่นๆ" });
        return "CSOTHERINCOME/SEARCH?";
      case "CSPAYMENT":
        this.setState({ Htext: "บันทึกจ่ายชำระหนี้" });
        return "CSPAYMENT/SEARCH?";
      case "CSRECEIPT":
        this.setState({ Htext: "บันทึกตัดบัญชีลูกหนี้/รับชำระ" });

        this.setState({ hiddenF: true })
        this.setState({ hiddenT: false })
        this.setState({ receipt: false })
        return "CSRECEIPT/Search?";
      case "CSARPAYBILL":
        this.setState({ Htext: "บันทึกใบวางบิล" });
        this.setState({ hiddenF: true })
        this.setState({ hiddenT: false })
        this.setState({ paybill: false })
        return "CSARPAYBILL/Search?";
      default:
        break;
    }
  };

  onSearch = async () => {

    this.setState({ openBackdrop: true })
    var url = this.ViewCSTV(this.props.from);
    url += "&DATE1=" + ReDate2(this.state.DATE1)//01/10/2564 redate 2021-10-01
    url += "&DATE2=" + ReDate2(this.state.DATE2)//05/10/2564 redate 2021-10-05
    url += "&DOCNO1=" + this.DOCNO1.current.value;
    url += "&DOCNO2=" + this.DOCNO2.current.value;
    url += "&DOCGROUP=" + this.DOCGROUP.current.value;
    url += "&PRCREATOR=" + this.PRCREATOR.current.value;
    url += "&top=" + this.top.current.value;
    var data = [];
    console.log(genURL(url));
    await axios.get(genURL(url)).then(async res => {
      if (res.data.length > 0 && res.data.length !== undefined) {
        for (var i = 0; i < res.data.length; i++) {
          data[i] = {
            C0: i + 1,
            C1: ReDate(res.data[i].DOCDATE),
            C2: res.data[i].DOCNO,
            C3: res.data[i].USERNAME,
            CScode: res.data[i].ARCODE,
            CSname: res.data[i].ARNAME,
            C4: res.data[i].REFDOCNO,
            C5: res.data[i].REMARK,
            Totalb: res.data[i].SUMPAYAMOUNT,
            Totalm: res.data[i].BATHPAYAMOUNT2,
          };
        }
        await this.setState({ rows: data });
        this.setState({ openBackdrop: false })
      } else {
        this.setState({ rows: data });
        this.setState({ openBackdrop: false })
      }
    }).catch(error => {
      this.setState({ openBackdrop: false })
      console.log(error);
      // this._chkload("Error" + error);
    });
  };
  SelectSetData = (data1, data2) => {
    switch (data1) {
      case "Calendar1":
        console.log('Calendar1', data2);
        this.setState({ DATE1: data2 })
        break;
      case "Calendar2":
        console.log('Calendar2', data2);
        this.setState({ DATE2: data2 })
        break;
      default:
        break;
    }
  };
  onSelectRow = (data) => {
    this.props.Get_Popup(data);
    this.props.closePopup();
  };
  KeyUp = (e) => {
    switch (e.target.id) {
      case "DOCNO1":
        this.DOCNO2.current.value = e.target.value;
        break;
      default:
        break;
    }
    if (e.key === "Enter") {
      this.onSearch();
    }
  };
  render() {
    return (
      <div className="popup">
        <Backdrop open={this.state.openBackdrop} />
        <div className="popup_inner" >
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-search"> {this.state.Htext} </i>
            </div>
            <div className="PopUpOtherDivH2">
              <i className="fas fa-times" onClick={this.props.closePopup}></i>
            </div>
          </div>
          <div className="panel-body divTable" align="right">
            <div className="row">
              <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={6} >
                    <MaterialUIPickers title="วันที่"
                      DateValue={e => this.SelectSetData("Calendar1", e)}
                      defaultdate={this.state.DATE1} />
                  </Grid>
                  <Grid item xs={6}>

                    <MaterialUIPickers title="ถึง"
                      DateValue={e => this.SelectSetData("Calendar2", e)}
                      defaultdate={this.state.DATE2} />

                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span className="input-group-addon"> เลขที่เอกสาร : </span>
                        <input
                          type="text"
                          className="form-control"
                          id="DOCNO1"
                          ref={this.DOCNO1}
                          onKeyUp={this.KeyUp}
                        />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span id="iconCreditCode" className="input-group-addon ">
                          ถึง :
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="DOCNO2"
                          ref={this.DOCNO2}
                          onKeyUp={this.KeyUp}
                        />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>

                  </Grid>
                  <Grid item xs={6} style={mystyle}>

                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span className="input-group-addon"> พนักงาน: </span>
                        <input
                          type="text"
                          className="form-control"
                          id="PRCREATOR"
                          ref={this.PRCREATOR}
                          onKeyUp={this.KeyUp}
                        />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span id="iconCreditCode" className="input-group-addon ">  กลุ่มเอกสาร :</span>
                        <input type="text" className="form-control" id="DOCGROUP" ref={this.DOCGROUP} onKeyUp={this.KeyUp} />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={6} style={mystyle}>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                      <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                        <span className="input-group-addon">จำนวนรายการ : </span>
                        <input type="text" className="form-control" ref={this.top} />
                        <span className="input-group-addon icon">
                          <i className="fab fa-expeditedssl"></i>
                        </span>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
            <button className="PUSDbtn" onClick={this.onSearch.bind(null)}>
              <i className="fas fa-search"> ค้นหา </i>
            </button>
            <div className="tess">
              <BootstrapTable
                data={this.state.rows}
                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูล", }}
                height="600"
                hover
                condensed
              >
                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField="C0" isKey></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField="C1"> วันที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="C2"> เลขที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="C3" hidden={this.state.hiddenF}> พนักงาน</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="C4" hidden={this.state.hiddenF}> ใบสั่งซื้อ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="CScode" hidden={this.state.hiddenT}> รหัสลูกค้า</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="CSname" hidden={this.state.hiddenT}> ชื่อลูกค้า</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField="C5"> หมายเหตุ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="Totalb" hidden={this.state.paybill}> ยอดรวมวางบิล</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="130" dataField="Totalm" hidden={this.state.receipt}> รวมเงินทั้งสิ้น</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
